export enum ContentAccessEnum {
  Interact = 'Interact',
  View = 'View',
  Restricted = 'Restricted',
}
